import { AppState } from '../../types'

const selectors = {
  getAll: (state: AppState) => state.monitoring.settings,
  selectedEnrichedCategory: (state: AppState) => selectors.getAll(state).selectedEnrichedCategory
}

export default selectors
